// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"_31vhcGP5OuU0VNLM2EHO3m","Canvas":"_1kGkagiDJkMkPxXEbZTDQ9","FormCard":"_1OPgOINBv3uIMLrk8lPxyT"};